import styled from 'styled-components';
import { colors } from 'tsx/theme';

const Div = styled.div`
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 23px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.2s;
    border-radius: 50px;
    // background-color: ${colors.primary};
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 21px;
    width: 21px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    transition: 0.2s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: ${colors.primary};
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(17px);
    -ms-transform: translateX(17px);
    transform: translateX(17px);
  }
`;

interface SwitchProps {
  checked?: boolean;
  onSelect: (a: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({ checked, onSelect }) => {
  return (
    <Div onClick={() => onSelect(!checked)}>
      <div className="switch">
        <input type="checkbox" checked={checked} />
        <span className="slider"></span>
      </div>
    </Div>
  );
};

export default Switch;
